import React from 'react'

const BannerTeam = (props) => (
  <section id="banner" className="style2">
    <div className="inner">
      <header className="major">
        <h1>Krypton Warriors</h1>
      </header>
      <div className="content">
        <p>
        A competitive FTC Team<br /> Located in Montville New Jersey
        </p>
      </div>
    </div>
  </section>
)

export default BannerTeam
